export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'tabela_nome',
    caption: 'Descrição'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
